import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tab, TabList, TabsContainer } from 'is24-corecss-server';
import _ from "lodash";
import NewWidgetTitle, { ALIGN } from '../../Utils/Widget/Title/NewWidgetTitle.jsx';
import PriceTrendChart from '../../PriceTrendChart/PriceTrendChart';
import { DesktopAndTablet, Mobile } from '../../Utils/MediaComponents/MediaComponents.jsx';
import PriceTrendChartMobile from '../../PriceTrendChart/PriceTrendChartMobile';
import { getStatsBoxData, getStatsBoxDataMobile } from '../Detailed/utils.js';
import { NO_DATA_TEXT } from '../../../utils/globals.js';
import { PRIMARY_BLUE, PRIMARY_GREEN } from '../../../utils/colorPalette';
import { getPricesForPriceHistoryWidget } from '../../../selectors/selectors.js';
import styles from './PriceHistoryWidgetWithRentPrice.less';

const PriceHistoryWidgetWithRentPrice = ({ realEstateType, address, prices, title, trackingAction }) => {
  const [activeTab, setActiveTab] = useState(0);
  const priceHistoryGraphTypes = ['BUY', 'RENT'];
  const apartmentPrices = prices[`APARTMENT_${priceHistoryGraphTypes[activeTab]}`];
  const housePrices = prices[`HOUSE_${priceHistoryGraphTypes[activeTab]}`];
  // TODO find a proper way to display if no data
  const noData = !apartmentPrices && !housePrices;
  if (noData) {
    return (
      <>
        <div className={`grid grid-flex grid-justify-space-between ${styles.widgetContainer}`}>
          <div className="grid-item one-whole align-center">
            <NewWidgetTitle id="price-history" align={ALIGN.left} text={`Immobilienpreisentwickling in ${address}`} />
          </div>
          <div className="grid-item one-whole align-center padding-vertical-xl padding-horizontal-xxl">
            {NO_DATA_TEXT}
          </div>
        </div>
      </>
    );
  }

  const commercializationType = priceHistoryGraphTypes[activeTab];
  const pricesPerQ = {
    apartments: apartmentPrices ? apartmentPrices.pricesPerQ : [],
    houses: housePrices ? housePrices.pricesPerQ : [],
  };
  const pricesPerYear = {
    apartments: apartmentPrices ? apartmentPrices.prices : [],
    houses: housePrices ? housePrices.prices : [],
  };
  const widgetTitle = _.isEmpty(title) ? `Immobilienpreisentwicklung in ${address} für Wohnungen und Häuser`: title;

  return (
    <>
      <div className={`grid grid-flex grid-justify-space-between ${styles.widgetContainer}`}>
        <div className="grid-item one-whole align-center">
          <NewWidgetTitle
            id="price-history"
            align={ALIGN.left}
            text={widgetTitle}
          />
        </div>
        <div className={`grid-item ${styles.tabsContainer}`}>
          <TabsContainer onClick={(clickedTab) => setActiveTab(clickedTab)} defaultSelected={0}>
            <TabList aria-label="Tab list">
              <Tab>Kaufpreise</Tab>
              <Tab>Mietpreise</Tab>
            </TabList>
          </TabsContainer>
        </div>
        <DesktopAndTablet
          render={() => (
            <>
              <div className={`grid-item one-whole ${styles.widget}`} id="price-history-chart">
                <PriceTrendChart
                  nativeData={pricesPerQ.apartments}
                  parentData={pricesPerQ.houses}
                  commercializationType={commercializationType}
                  items={[
                    { color: PRIMARY_BLUE(), text: 'Wohnungen' },
                    { color: PRIMARY_GREEN(), text: 'Häuser' },
                  ]}
                  hideHeader
                  showMpPromoDialog={priceHistoryGraphTypes[activeTab] === 'BUY'}
                  trackingAction={trackingAction}
                  getStatsBoxData={(selected) =>
                    getStatsBoxData(selected, pricesPerQ.apartments, pricesPerQ.houses, 'Wohnungen', 'Häuser')
                  }
                />
              </div>
            </>
          )}
        />
        <Mobile
          render={() => (
            <>
              <div className={`grid-item one-whole margin-top-l ${styles.widget}`} id="price-history-chart-mobile">
                <PriceTrendChartMobile
                  hideHeader
                  hideSeparator
                  nativeDataMobile={pricesPerYear.apartments}
                  parentDataMobile={pricesPerYear.houses}
                  realEstateType={realEstateType}
                  commercializationType={commercializationType}
                  showMpPromoDialog={priceHistoryGraphTypes[activeTab] === 'BUY'}
                  trackingAction={trackingAction}
                  getStatsBoxDataMobile={(selected) =>
                    getStatsBoxDataMobile(
                      selected,
                      pricesPerYear.apartments,
                      pricesPerYear.houses,
                      'Wohnungen',
                      'Häuser',
                    )
                  }
                />
              </div>
            </>
          )}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  prices: getPricesForPriceHistoryWidget(state),
});

PriceHistoryWidgetWithRentPrice.defaultProps = {
  address: null,
  prices: null,
  title: '',
};

PriceHistoryWidgetWithRentPrice.propTypes = {
  address: PropTypes.string,
  prices: PropTypes.object,
  title: PropTypes.string,
  realEstateType: PropTypes.string.isRequired,
  trackingAction: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(PriceHistoryWidgetWithRentPrice);
